import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index.vue";
import ProductDetails from "../views/ProductDetailsView.vue";
import About from "../components/about/index";
import Case from "../components/case/index";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/about",
    name: "about",
    component: About
  },
  {
    path: "/case",
    name: "case",
    component: Case
  },
  {
    path: "/productDetails",
    name: "productDetails",
    component: ProductDetails
  }
];

const router = new VueRouter({
  routes
});

export default router;
